import {
  AccountTypeEnum,
  JointAccountTypeEnum,
  ProfileRelationshipEnum,
} from "~/graphql/supergraphEnums";
import {
  type AccountTypeEnum as AccountType,
  type ComplianceJointProfileInput,
} from "~/graphql/supergraphTypes";
import { type ProfileDetailsType } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/types";
import { getOwnershipPercentage } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/utils";
import { type FormValues } from "./types";

export const EMPTY_FORM_VALUES: FormValues = {
  jointType: null,
  name: "",
  ownershipPercentage: null,
  domicileCountry: "",
};

export const accountTypeToJointEnum = (
  value: AccountType | null | undefined,
): JointAccountTypeEnum | null => {
  switch (value) {
    case AccountTypeEnum.Joint:
      return JointAccountTypeEnum.Joint;
    case AccountTypeEnum.Tic:
      return JointAccountTypeEnum.Tic;
    case AccountTypeEnum.JointOther:
      return JointAccountTypeEnum.JointOther;
  }
  return null;
};

export const buildInitialValues = (
  complianceProfile?: ProfileDetailsType | null,
): FormValues => {
  if (!complianceProfile) return EMPTY_FORM_VALUES;

  const primaryAddress = complianceProfile.addresses.find((a) => a.isPrimaryDomicile);

  return {
    jointType: accountTypeToJointEnum(complianceProfile.accountType),
    name: complianceProfile.legalName ?? "",
    ownershipPercentage: getOwnershipPercentage(complianceProfile.parentRelationships) ?? null,
    domicileCountry: primaryAddress?.country?.alpha2code ?? "",
  };
};

export const buildMutationData = (
  values: FormValues,
  caseId: number,
  isRootProfile: boolean = false,
): ComplianceJointProfileInput => ({
  accountType: values.jointType,
  legalBusinessName: values.name,
  ownershipPercentage: values.ownershipPercentage ?? undefined,
  relationshipType: isRootProfile ? undefined : [ProfileRelationshipEnum.Owner],
  addresses: values.domicileCountry
    ? [{ addressType: "primary_domicile", domicile: values.domicileCountry }]
    : undefined,
  caseId: caseId,
});
